import {Theme} from '@lookiero/aurora';
import StyleSheet from 'react-native-extended-stylesheet';

const {space3, space4, space6} = Theme.get();

export const style = StyleSheet.create({
  wrapper: {
    paddingVertical: space3,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: space6,
  },
  title: {
    marginLeft: space4,
    marginTop: -4, // Hack to align with the text
    flexShrink: 1,
  },
});
